import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink, ButtonExternal } from '../ui/Button';
import { EventCard } from '../events/EventCard';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleSquiggle } from '../brand/Doodles';
import { visibleSpecialEvents } from '../../data/events';
import { externalLinks, scheduleDisclaimer } from '../../data/site';
export function UpcomingEvents() {
  return <Section className="relative overflow-hidden bg-brand-blue py-16 sm:py-20" labelledBy="events-heading" data-id="element-238" data-mp="aw0dp381cpns">
      <DoodleSquiggle className="pointer-events-none absolute -right-6 top-8 h-10 w-40 opacity-70" color="var(--bcm-dark-blue)" data-id="element-239" data-mp="fpl2q5rni9au" />
      <Container data-id="element-240" data-mp="5xyu8h6p6obs">
        <Reveal data-id="element-241" data-mp="5zicuefttbgq">
          <div className="max-w-2xl" data-id="element-242" data-mp="5z06gozg9gv3">
            <h2 id="events-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-5xl" data-id="element-243" data-mp="3o43fgksjed0s">
              What’s happening at BCM
            </h2>
            <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-244" data-mp="39cxtu9gqrfz5">
              Start with a worship night, join us during Welcome Week, or connect with someone who can
              help you find your place.
            </p>
          </div>
        </Reveal>

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-245" data-mp="3dfu67ifoufun">
          {visibleSpecialEvents.map((event, index) => <Reveal key={event.id} as="li" delay={stagger(index)} className="h-full" data-id="element-246" data-mp="2pp892m782fzf" data-mpi={index}>
              <EventCard event={event} data-id="element-247" data-mp="2loo8t9rcqw92" />
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-248" data-mp="2zft4y1vih6en">
          <p className="mt-6 font-meta text-[12.5px] leading-relaxed text-ink" data-id="element-249" data-mp="2zg2trm4tl7ir">
            {scheduleDisclaimer}
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row" data-id="element-250" data-mp="2unjkh1d60yjr">
            <ButtonLink to="/events" data-id="element-251" data-mp="26yqjgqhos0ia">See All Events</ButtonLink>
            <ButtonExternal href={externalLinks.getConnectedForm} variant="secondary" data-id="element-252" data-mp="26x5ox0vdghkf">
              Get Event Updates
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}